import { useEffect, useState } from 'react';
import { api, formatPKR } from '../api';
import PageHeader from '../components/PageHeader';
import ConfirmDialog from '../components/ConfirmDialog';

export default function Products() {
  const [products, setProducts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [deactivateId, setDeactivateId] = useState(null);
  const [form, setForm] = useState({
    name: '',
    price: '',
    stock: '0',
    shortDescription: '',
    category: 'General',
    imageUrl: '',
  });
  const [error, setError] = useState('');

  const load = () => api.getProducts().then(setProducts).catch((e) => setError(e.message));

  useEffect(() => {
    load();
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      await api.addProduct({
        ...form,
        price: Number(form.price),
        stock: Number(form.stock),
      });
      setShowForm(false);
      setForm({ name: '', price: '', stock: '0', shortDescription: '', category: 'General', imageUrl: '' });
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleDeactivate = async () => {
    try {
      await api.deactivateProduct(deactivateId);
      setDeactivateId(null);
      load();
    } catch (err) {
      setError(err.message);
      setDeactivateId(null);
    }
  };

  return (
    <div>
      <PageHeader title="Products" subtitle="Manage product catalog" />
      <button type="button" onClick={() => setShowForm(!showForm)} className="btn-primary mb-6">
        {showForm ? 'Cancel' : 'Add New Product'}
      </button>

      {showForm && (
        <form onSubmit={handleAdd} className="card mb-8 grid md:grid-cols-2 gap-4">
          <input
            placeholder="Product Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="input"
            required
          />
          <input
            type="number"
            placeholder="Price"
            value={form.price}
            onChange={(e) => setForm({ ...form, price: e.target.value })}
            className="input"
            required
          />
          <input
            type="number"
            placeholder="Initial Stock"
            value={form.stock}
            onChange={(e) => setForm({ ...form, stock: e.target.value })}
            className="input"
          />
          <input
            placeholder="Category"
            value={form.category}
            onChange={(e) => setForm({ ...form, category: e.target.value })}
            className="input"
          />
          <input
            placeholder="Image URL"
            value={form.imageUrl}
            onChange={(e) => setForm({ ...form, imageUrl: e.target.value })}
            className="input md:col-span-2"
          />
          <textarea
            placeholder="Short Description"
            value={form.shortDescription}
            onChange={(e) => setForm({ ...form, shortDescription: e.target.value })}
            className="input md:col-span-2"
            rows={2}
          />
          <button type="submit" className="btn-primary md:col-span-2">
            Create Product
          </button>
        </form>
      )}

      {error && <p className="text-red-600 mb-4">{error}</p>}

      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Price</th>
              <th>Stock</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.id} className={!p.active ? 'text-red-600' : ''}>
                <td className={!p.active ? 'line-through' : ''}>{p.name}</td>
                <td>{formatPKR(p.price)}</td>
                <td>{p.stock}</td>
                <td>
                  {p.active ? (
                    <span className="badge badge-dispatched">Active</span>
                  ) : (
                    <span className="badge badge-inactive">Inactive</span>
                  )}
                </td>
                <td>
                  {p.active && (
                    <button
                      type="button"
                      className="btn-danger text-xs"
                      onClick={() => setDeactivateId(p.id)}
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ConfirmDialog
        open={!!deactivateId}
        title="Deactivate Product"
        message="This will mark the product as inactive (shown in red). Historical data will be preserved."
        confirmLabel="Deactivate"
        onConfirm={handleDeactivate}
        onCancel={() => setDeactivateId(null)}
      />
    </div>
  );
}
